import { render, staticRenderFns } from "./PreOrderAzProduct.vue?vue&type=template&id=5b721d5e&scoped=true&"
import script from "./PreOrderAzProduct.vue?vue&type=script&lang=js&"
export * from "./PreOrderAzProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b721d5e",
  null
  
)

export default component.exports